import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle, Route, PRIMARY_OUTLET } from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private storedRoutes = new Map<string, DetachedRouteHandle>();

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    let config: Route = route.routeConfig;
    return !!route.data?.reuse && (config && !config.loadChildren);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    let config: Route = route.routeConfig;
    return !!config && !!this.storedRoutes.get(this.getRoutePath(route));
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    let config: Route = route.routeConfig;
    if (!config || config.loadChildren) return false;
    return this.storedRoutes.get(this.getRoutePath(route));
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    let path: string = this.getRoutePath(route);
    // this.storedRoutes[path] = handle;
    this.storedRoutes.set(path, handle);
    let config: Route = route.routeConfig;
    // if (!config) 
    return;

    let childRoute: ActivatedRouteSnapshot = route.firstChild;
    let futureRedirectTo = childRoute ? childRoute.url.map(function (urlSegment) {
      return urlSegment.path;
    }).join('/') : '';
    let childRouteConfigs: Route[] = config.children;
    if (childRouteConfigs) {
      let redirectConfigIndex: number;
      let redirectConfig: Route = childRouteConfigs.find(function (childRouteConfig, index) {
        if (childRouteConfig.path === '' && !!childRouteConfig.redirectTo) {
          redirectConfigIndex = index;
          return true;
        }
        return false;
      });
      //Redirect route exists
      if (redirectConfig) {
        if (futureRedirectTo !== '') {
          //Current activated route has child routes, update redirectTo
          redirectConfig.redirectTo = futureRedirectTo;
        } else {
          //Current activated route has no child routes, remove the redirect (otherwise retrieval will always fail for this route)
          childRouteConfigs.splice(redirectConfigIndex, 1);
        }
      } else if (futureRedirectTo !== '') {
        childRouteConfigs.push({
          path: '',
          redirectTo: futureRedirectTo,
          pathMatch: 'full'
        });
      }
    }
  }


  getRoutePath(route: ActivatedRouteSnapshot): string {
    let namedOutletCount: number = 0;
    return route.pathFromRoot.reduce((path, route) => {
      let config: Route = route.routeConfig;
      if (config) {
        if (config.outlet && config.outlet !== PRIMARY_OUTLET) {
          path += `(${config.outlet}:`;
          namedOutletCount++;
        } else {
          path += '/';
        }
        return path += config.path
      }
      return path;
    }, '') + (namedOutletCount ? new Array(namedOutletCount + 1).join(')') : '');
  }
}